import React from "react";
import Cookies from "universal-cookie";
import Fade from './Fade.js';
 


export class WidgetTemplateVk extends React.Component {

    
    constructor(props) {
        super(props);
        this.refFirstStage = React.createRef();
        
    }

   
    

    
    

    transormLinks(x) {
        var res = x.match( /\[link\]\s*(.+?)\s*\[\/link\]/g )
        var link;
        if (res != null) {
            for (var i = 0; i < res.length; i++) {
                console.log( res[i] )
                link = res[i].replace('[link]', '').replace('[/link]', '')
                x = x.replace(res[i], '<a href="'+ link +'">'+ link+'</a>')
                
            }
        }
        
        return x
     }

     transformSpaces(a) {

        var b = '\u00a0'
        var l = ['из-за', 'чтобы']
        var new_sentence = ''
        var words = a.split(' ')
        var word;
        for (var i=0; i<words.length; i++) {
            word =  words[i]
            if (word.length <= 3 || (l.indexOf(word) > -1)) {
                new_sentence += word + b
            }
            else {
                new_sentence += word + ' '
            }
            
        }
        new_sentence = new_sentence.replace('-', '\u2011')
        
       return new_sentence
    }

    render() {
        return (
            <div className='reset-this'>
            <div className={ 
             this.props.show   ? 
            "WidgetTemplate_bodyBackground" 
            :
             "WidgetTemplate_bodyBackground hidden"}></div>
            <div className={ 
             this.props.show   ? 
            "WidgetTemplate_widget " 
            :
             "WidgetTemplate_widget hidden "}>    
                <div className="WidgetTemplate_widget_inner">
                 
                    <img onClick={(e) => {
                        
                        this.props.setShowPreview(e, !true)
                    }
                    } id="doClose" className="WidgetTemplate_widgetCloseIcon" src="https://storage.yandexcloud.net/clientsaverstatic/close-icon.svg" />
                     <img 
                    onClick={(e) => {
                        
                        this.props.setShowPreview(e, !true)
                    }}
                    className='WidgetTemplate_widgetCloseIcon WidgetTemplate_widgetCloseIcon_mobile' 
                    src='https://storage.yandexcloud.net/clientsaverstatic/close-icon-mobile.svg' />

                <div  className='WidgetTemplate_rightSide'>
                    <img  className='WidgetTemplate_desktopImage' src={this.props.big_img_src} />
                    <img  className="WidgetTemplate_mobileImage" src={this.props.small_img_src} />
                </div>
                <div  className='WidgetTemplate_leftSide'>
                    <div  className='WidgetTemplate_leftSide_inner'>
                    <div className="WidgetTemplate_leftSide_mainBlock">
                        
                            <div ref={this.refFirstStage} className= "WidgetTemplate_firstStage">
                            
                            
                                <h1>{this.transformSpaces(this.props.header_text)}</h1>
                                <h2> {this.transformSpaces(this.props.main_text)}</h2>                    
                                <div  className='WidgetTemplate_buttonBlock'> 
                                <a target='_blank' href={ 'https://vk.me/club'+this.props.group_id} className="WidgetTemplate_firstStageButton" > Получить <img src='https://storage.yandexcloud.net/clientsaverstatic/vk_white.svg' />  </a>
                                </div>
                                <div className="WidgetTemplate_poweredByBlock">
                                    Создано на <a href="#">clientsaver</a>
                                </div>
                            </div>
                        
                        
                          
                    </div>            
                    </div>        
                    </div>   
                     </div>
                     </div>
                      </div>
        )
    }
}

